import { useEffect } from 'react';

function upsertTag(selector, createTag, updateAttributes) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = createTag();
    document.head.appendChild(tag);
  }
  updateAttributes(tag);
}

export default function Metadata({
  title,
  description,
  image,
  path,
  canonical,
  lang = 'da',
  noindex = false,
}) {
  useEffect(() => {
    if (!title) return;

    document.title = title;
    document.documentElement.lang = lang;

    upsertTag(
      'meta[name="description"][data-rs-byg-meta="description"]',
      () => {
        const tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        tag.setAttribute('data-rs-byg-meta', 'description');
        return tag;
      },
      (tag) => {
        tag.setAttribute('content', description || '');
      },
    );

    upsertTag(
      'meta[name="robots"][data-rs-byg-meta="robots"]',
      () => {
        const tag = document.createElement('meta');
        tag.setAttribute('name', 'robots');
        tag.setAttribute('data-rs-byg-meta', 'robots');
        return tag;
      },
      (tag) => {
        tag.setAttribute('content', noindex ? 'noindex,nofollow' : 'index,follow');
      },
    );

    const canonicalUrl = canonical || (path ? `${window.location.origin}${path}` : window.location.href);
    upsertTag(
      'link[rel="canonical"][data-rs-byg-meta="canonical"]',
      () => {
        const tag = document.createElement('link');
        tag.setAttribute('rel', 'canonical');
        tag.setAttribute('data-rs-byg-meta', 'canonical');
        return tag;
      },
      (tag) => {
        tag.setAttribute('href', canonicalUrl);
      },
    );

    const metaPairs = [
      ['og:title', title],
      ['og:description', description || ''],
      ['og:type', 'website'],
      ['og:url', canonicalUrl],
      ['twitter:card', image ? 'summary_large_image' : 'summary'],
      ['twitter:title', title],
      ['twitter:description', description || ''],
    ];

    if (image) {
      metaPairs.push(['og:image', image], ['twitter:image', image]);
    }

    metaPairs.forEach(([property, content]) => {
      const selector = `meta[property="${property}"][data-rs-byg-meta="${property}"]`;
      upsertTag(
        selector,
        () => {
          const tag = document.createElement('meta');
          tag.setAttribute('property', property);
          tag.setAttribute('data-rs-byg-meta', property);
          return tag;
        },
        (tag) => {
          tag.setAttribute('content', content);
        },
      );
    });
  }, [title, description, image, path, canonical, lang, noindex]);

  return null;
}
